
import { Action } from '@ngrx/store';


export enum EWarehouseActions {
    CreateReleaseMaterialProducts = '[ReleaseMaterialProducts] Create ReleaseMaterialProducts',
    CreateReleaseMaterialProductsSuccess = '[ReleaseMaterialProducts] Set Create ReleaseMaterialProducts Success',
    CreateReleaseMaterialProductsError = '[ReleaseMaterialProducts] Set Create ReleaseMaterialProducts Error',
    CreateReceiveProducts = '[ReceiveProducts] Create ReceiveProducts',
    GetReceiveProductsSuccess = '[ReceiveProducts] Set Create ReceiveProducts Success',
    GetReceiveProductsError = '[ReceiveProducts] Set Create ReceiveProducts Error',
    EditReceiveProduct = '[ReceiveProducts] Edit ReceiveProduct',
    GetEditReceiveProductSuccess = '[ReceiveProducts] Get Edit ReceiveProduct Success',
    GetEditReceiveProductError = '[] Get Edit ReceiveProduct Error',
    //Reject Material
    GetAllRejectMaterials = '[RejectMaterials] Get All Reject Materials',
    GetAllRejectMaterialsSuccess = '[RejectMaterials] Get All Reject Materials Success',
    GetAllRejectMaterialsError = '[RejectMaterials] Get All Reject Materials Error',
    AddRejectMaterial = '[RejectMaterials] Add Reject Material',
    GetAddRejectMaterialSuccess = '[RejectMaterials] Add Reject Material Success',
    GetAddRejectMaterialError ='[RejectMaterials] Add Reject Material Error',
    AddRejectProduct = '[RejectProducts] Add Reject Product',
    GetAddRejectProductSuccess = '[RejectProducts] Add Reject Product Success',
    GetAddRejectProductError = '[RejectProducts] Add Reject Product Error',
    EditRejectMaterial_product = '[RejectMaterials] Edit Reject Material',
    GetEditRejectMaterial_productSuccess = '[RejectMaterials] Edit Reject Material Success',
    GetEditRejectMaterial_productError = '[RejectMaterials] Edit Reject Material Error',
    // EditRejectProduct = '[RejectMaterials] Edit Reject Product',
    // GetEditRejectProductSuccess = '[RejectMaterials] Edit Reject Product Success',
    // GetEditRejectProductError = '[RejectMaterials] Edit Reject Product Error',
    GetMlos = '[RejectMaterials] Get Mlos',
    GetMlosSuccess = '[RejectMaterials] Get Mlos Success',
    GetMlosError = '[RejectMaterials] Get Mlos Error',
    GetRecLotsByMaterialID = '[RejectMaterials] Get RecLots',
    GetRecLotsByMaterialIDSuccess = '[RejectMaterials] Get RecLots Success',
    GetRecLotsByMaterialIDError = '[RejectMaterials] Get RecLots Error',
    GetRecLotsByMaterialIDList = '[RejectMaterials] Get RecLotsList',
    GetRecLotsByMaterialIDListSuccess = '[RejectMaterials] Get RecLotsList Success',
    GetRecLotsByMaterialIDListError = '[RejectMaterials] Get RecLotsList Error',


    //return material
    AddReturnMaterial = '[ReturnMaterial] Add Return Material',
    GetAddReturnMaterialSuccess = '[ReturnMaterial] Add Return Material Success',
    GetAddReturnMaterialError = '[ReturnMaterial] Add Return Material Error',
    EditReturnMaterial = '[ReturnMaterial] Edit Return Material',
    GetEditReturnMaterialSuccess = '[ReturnMaterial] Edit Return Material Success',
    GetEditReturnMaterialError = '[ReturnMaterial] Edit Return Material Error',

    //Receive product
    GetRecProductsByFormulaID = '[ReceiveProducts] Get ReceiveProducts By Formula Id',
    GetRecProductsByFormulaIDSuccess = '[ReceiveProducts] Get ReceiveProducts By Formula Id Success',
    GetRecProductsByFormulaIDError = '[ReceiveProducts] Get ReceiveProducts By Formula Id Error',

    UpdateSohValue = '[checkmat] Update SOH Value',
    GetUpdateSohValueSuccess = '[checkmat] Get Update SOH Value Success',
    GetUpdateSohValueError = '[checkmat] Get Update SOH Value Error',

    GetReceivedQtyByFormulaId = '[ReceiveProducts] Get Received Qty By FormulaId',
    GetReceivedQtyByFormulaIdSuccess = '[ReceiveProducts] Get Received Qty By FormulaId Success',
    GetReceivedQtyByFormulaIdError = '[] Get Received Qty By FormulaId Error',

    //miscellaneousReason

    GetMiscellaneousReasons='[MiscellaneousReasons] Get MiscellaneousReasons',
    GetMiscellaneousReasonsSuccess='[MiscellaneousReasons] Get MiscellaneousReasons Success',
    GetMiscellaneousReasonsError='[] Get MiscellaneousReasons Error',
    AddMiscellaneousReason='[MiscellaneousReasons] Add MiscellaneousReason',
    AddMiscellaneousReasonSuccess='[MiscellaneousReasons] Add MiscellaneousReason Success',
    AddMiscellaneousReasonError='[] Add MiscellaneousReason Error'




}
export class CreateReleaseMaterialProducts implements Action {
    public readonly type = EWarehouseActions.CreateReleaseMaterialProducts;
    constructor(public payload: any) {}
}

export class CreateReleaseMaterialProductsSuccess implements Action {
    public readonly type = EWarehouseActions.CreateReleaseMaterialProductsSuccess;
    constructor(public payload: any) {
    }
}

export class CreateReleaseMaterialProductsError implements Action {
    public readonly type = EWarehouseActions.CreateReleaseMaterialProductsError;
    constructor(public payload: any) {
    }
}

export class  CreateReceiveProducts implements Action {
      public readonly type = EWarehouseActions.CreateReceiveProducts;
      constructor(public payload: any) {}
}
export class  GetReceiveProductsSuccess implements Action {
      public readonly type = EWarehouseActions.GetReceiveProductsSuccess;
      constructor(public payload: any) {}
}
export class  GetReceiveProductsError implements Action {
      public readonly type = EWarehouseActions.GetReceiveProductsError;
      constructor(public payload: any) {}
}

export class  EditReceiveProduct implements Action {
    public readonly type = EWarehouseActions.EditReceiveProduct;
    constructor(public payload: any) {}
}
export class  GetEditReceiveProductSuccess implements Action {
    public readonly type = EWarehouseActions.GetEditReceiveProductSuccess;
    constructor(public payload: any) {}
}
export class  GetEditReceiveProductError implements Action {
    public readonly type = EWarehouseActions.GetEditReceiveProductError;
    constructor(public payload: any) {}
}
//Reject Materials
export class GetAllRejectMaterials implements Action {
    public readonly type = EWarehouseActions.GetAllRejectMaterials;
    constructor(public payload: any) {}
}
export class GetAllRejectMaterialsSuccess implements Action {
    public readonly type = EWarehouseActions.GetAllRejectMaterialsSuccess;
    constructor(public payload: any) {}
}
export class GetAllRejectMaterialsError implements Action {
    public readonly type = EWarehouseActions.GetAllRejectMaterialsError;
    constructor(public payload: any) {}
}
export class AddRejectMaterial implements Action {
    public readonly type = EWarehouseActions.AddRejectMaterial;
    constructor(public payload: any) {}
}
export class GetAddRejectMaterialSuccess implements Action {
    public readonly type = EWarehouseActions.GetAddRejectMaterialSuccess;
    constructor(public payload: any) {}
}
export class GetAddRejectMaterialError implements Action {
    public readonly type = EWarehouseActions.GetAddRejectMaterialError;
    constructor(public payload: any) {}
}
export class AddRejectProduct  implements Action {
    public readonly type = EWarehouseActions.AddRejectProduct ;
    constructor(public payload: any) {}
}
export class GetAddRejectProductSuccess  implements Action {
    public readonly type = EWarehouseActions.GetAddRejectProductSuccess ;
    constructor(public payload: any) {}
}
export class GetAddRejectProductError  implements Action {
    public readonly type = EWarehouseActions.GetAddRejectProductError ;
    constructor(public payload: any) {}
}
export class EditRejectMaterial_product  implements Action {
    public readonly type = EWarehouseActions.EditRejectMaterial_product;
    constructor(public payload: any) {}
}
export class GetEditRejectMaterial_productSuccess  implements Action {
    public readonly type = EWarehouseActions.GetEditRejectMaterial_productSuccess;
    constructor(public payload: any) {}
}
export class GetEditRejectMaterial_productError  implements Action {
    public readonly type = EWarehouseActions.GetEditRejectMaterial_productError;
    constructor(public payload: any) {}
}
// export class EditRejectProduct  implements Action {
//     public readonly type = EWarehouseActions.EditRejectProduct ;
//     constructor(public payload: any) {}
// }
// export class GetEditRejectProductSuccess  implements Action {
//     public readonly type = EWarehouseActions.GetEditRejectProductSuccess;
//     constructor(public payload: any) {}
// }
// export class GetEditRejectProductError  implements Action {
//     public readonly type = EWarehouseActions.GetEditRejectProductError;
//     constructor(public payload: any) {}
// }
//Return Material
export class AddReturnMaterial  implements Action {
    public readonly type = EWarehouseActions.AddReturnMaterial;
    constructor(public payload: any) {}
}
export class GetAddReturnMaterialSuccess  implements Action {
    public readonly type = EWarehouseActions.GetAddReturnMaterialSuccess;
    constructor(public payload: any) {}
}
export class GetAddReturnMaterialError  implements Action {
    public readonly type = EWarehouseActions.GetAddReturnMaterialError;
    constructor(public payload: any) {}
}
export class EditReturnMaterial  implements Action {
    public readonly type = EWarehouseActions.EditReturnMaterial;
    constructor(public payload: any) {}
}
export class GetEditReturnMaterialSuccess  implements Action {
    public readonly type = EWarehouseActions.GetEditReturnMaterialSuccess;
    constructor(public payload: any) {}
}
export class GetEditReturnMaterialError  implements Action {
    public readonly type = EWarehouseActions.GetEditReturnMaterialError;
    constructor(public payload: any) {}
}
export class GetMlos  implements Action {
    public readonly type = EWarehouseActions.GetMlos;
    constructor(public payload: any) {}
}
export class GetMlosSuccess  implements Action {
    public readonly type = EWarehouseActions.GetMlosSuccess;
    constructor(public payload: any) {}
}
export class GetMlosError  implements Action {
    public readonly type = EWarehouseActions.GetMlosError;
    constructor(public payload: any) {}
}
export class GetRecLotsByMaterialID  implements Action {
    public readonly type = EWarehouseActions.GetRecLotsByMaterialID;
    constructor(public payload: any) {}
}
export class GetRecLotsByMaterialIDSuccess  implements Action {
    public readonly type = EWarehouseActions.GetRecLotsByMaterialIDSuccess;
    constructor(public payload: any) {}
}
export class GetRecLotsByMaterialIDError  implements Action {
    public readonly type = EWarehouseActions.GetRecLotsByMaterialIDError;
    constructor(public payload: any) {}
}
export class GetRecLotsByMaterialIDList  implements Action {
  public readonly type = EWarehouseActions.GetRecLotsByMaterialIDList;
  constructor(public payload: any) {}
}
export class GetRecLotsByMaterialIDListSuccess  implements Action {
    public readonly type = EWarehouseActions.GetRecLotsByMaterialIDListSuccess;
    constructor(public payload: any) {}
}
export class GetRecLotsByMaterialIDListError  implements Action {
    public readonly type = EWarehouseActions.GetRecLotsByMaterialIDListError;
    constructor(public payload: any) {}
}
export class GetRecProductsByFormulaID implements Action {
    public readonly type = EWarehouseActions.GetRecProductsByFormulaID;
    constructor(public payload: any) {}
}
export class GetRecProductsByFormulaIDSuccess implements Action {
    public readonly type = EWarehouseActions.GetRecProductsByFormulaIDSuccess;
    constructor(public payload: any) {}
}
export class GetRecProductsByFormulaIDError implements Action {
    public readonly type = EWarehouseActions.GetRecProductsByFormulaIDError;
    constructor(public payload: any) {}
}
export class UpdateSohValue implements Action {
    public readonly type = EWarehouseActions.UpdateSohValue;
    constructor(public payload: any) {}
}
export class GetUpdateSohValueSuccess implements Action {
    public readonly type = EWarehouseActions.GetUpdateSohValueSuccess;
    constructor(public payload: any) {}
}
export class GetUpdateSohValueError implements Action {
    public readonly type = EWarehouseActions.GetUpdateSohValueError;
    constructor(public payload: any) {}
}
export class GetReceivedQtyByFormulaId implements Action {
    public readonly type = EWarehouseActions.GetReceivedQtyByFormulaId;
    constructor(public payload: any) {}
}
export class GetReceivedQtyByFormulaIdSuccess implements Action {
    public readonly type = EWarehouseActions.GetReceivedQtyByFormulaIdSuccess;
    constructor(public payload: any) {}
}
export class GetReceivedQtyByFormulaIdError implements Action {
    public readonly type = EWarehouseActions.GetReceivedQtyByFormulaIdError;
    constructor(public payload: any) {}
}
export class GetMiscellaneousReasons implements Action {
    public readonly type = EWarehouseActions.GetMiscellaneousReasons;
    constructor(public payload: any) {}
}
export class GetMiscellaneousReasonsSuccess implements Action {
    public readonly type = EWarehouseActions.GetMiscellaneousReasonsSuccess;
    constructor(public payload: any) {}
}
export class GetMiscellaneousReasonsError implements Action {
    public readonly type = EWarehouseActions.GetMiscellaneousReasonsError;
    constructor(public payload: any) {}
}
export class AddMiscellaneousReason implements Action {
    public readonly type = EWarehouseActions.AddMiscellaneousReason;
    constructor(public payload: any) {}
}
export class AddMiscellaneousReasonSuccess implements Action {
    public readonly type = EWarehouseActions.AddMiscellaneousReasonSuccess;
    constructor(public payload: any) {}
}
export class AddMiscellaneousReasonError implements Action {
    public readonly type = EWarehouseActions.AddMiscellaneousReasonError;
    constructor(public payload: any) {}
}
export type WarehouseAction =  CreateReleaseMaterialProducts | CreateReleaseMaterialProductsSuccess | CreateReleaseMaterialProductsError |
                              CreateReceiveProducts | GetReceiveProductsSuccess | GetReceiveProductsError| GetAllRejectMaterials|
                              GetAllRejectMaterialsSuccess| GetAllRejectMaterialsError |  AddRejectMaterial |GetAddRejectMaterialSuccess|
                              GetAddRejectMaterialError|AddRejectProduct|GetAddRejectProductSuccess|GetAddRejectProductError|
                              EditRejectMaterial_product|GetEditRejectMaterial_productSuccess|GetEditRejectMaterial_productError
                             |AddReturnMaterial|GetAddReturnMaterialSuccess|GetAddReturnMaterialError|EditReturnMaterial|GetEditReturnMaterialSuccess|
                              GetEditReturnMaterialError|GetMlos|GetMlosSuccess|GetMlosError|GetRecLotsByMaterialID|GetRecLotsByMaterialIDSuccess|
                              GetRecLotsByMaterialIDError | GetRecProductsByFormulaID | GetRecProductsByFormulaIDSuccess | GetRecProductsByFormulaIDError
                              |EditReceiveProduct | GetEditReceiveProductSuccess  | GetEditReceiveProductError | UpdateSohValue | GetUpdateSohValueSuccess|
                              GetUpdateSohValueError| GetReceivedQtyByFormulaId| GetReceivedQtyByFormulaIdSuccess| GetReceivedQtyByFormulaIdError
                              |GetMiscellaneousReasons|GetMiscellaneousReasonsSuccess|GetMiscellaneousReasonsError|AddMiscellaneousReason|
                              AddMiscellaneousReasonSuccess|AddMiscellaneousReasonError| GetRecLotsByMaterialIDList| GetRecLotsByMaterialIDListSuccess| GetRecLotsByMaterialIDListError;




